const ESV_API = 'bbc2a930dcc019b8b9b73e3203919a258ad96ba2';

module.exports = ESV_API;